import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { SidebarContext } from '../../../layouts/Technician/index';
import styles from './index.module.scss';
import Job from './Job';
interface Props {}

const TechnicianJobDetails: React.FC<Props> = () => {
  const { setCurrentItem, setCurrentPage } = useContext(SidebarContext);
  const { id } = useParams();
  const [orderId, setOrderId] = useState<String>();

  useEffect(() => {
    if (id) setCurrentItem(id);
    setOrderId(id);
    setCurrentPage('jobs-detail');
  }, [id]);

  return (
    <div className={styles.job}>
      <Job orderId={orderId} />
    </div>
  );
};

export default TechnicianJobDetails;
